import { render, staticRenderFns } from "./DuplicateIcon.vue?vue&type=template&id=f9d56f3e&"
import script from "./DuplicateIcon.vue?vue&type=script&lang=js&"
export * from "./DuplicateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports